var EXTERNAL_MENTIONS_TYPE="wix-draft-plugin-external-mentions",MENTION_TYPE="mention";export{EXTERNAL_MENTIONS_TYPE,MENTION_TYPE};
//# sourceMappingURL=types.js.map
